module.exports = __webpack_public_path__ + "static/media/veneto-village-03.e338d0e2.jpg";